import axios from "axios";
import { store } from "../store/store.tsx";

// export const BASE_URL = "https://backendapp.phototime.biz/v2/";
// export const BASE_URL = "https://h67gq76s-3009.asse.devtunnels.ms/v2/";
// export const BASE_URL = "http://localhost:3000/v2/";
// export const BASE_URL =
//   "https://volunteer-athens-allow-lid.trycloudflare.com/v2/";

// export const BASE_URL = "https://testbe.phototime.biz/v2/";


// export const BASE_URL = "https://dev-be-phototime.phototime.biz/v2/";
export const BASE_URL = "https://backendapp.phototime.biz/v2/";
// 

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    // const token = useAuthStore.getState().token;
  const state = store.getState();
  const auth = state.auth;
    if (auth) {
      config.headers["Authorization"] = `Bearer ${auth.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.request.use(
  (config) => {
   const state = store.getState();
  const auth = state.auth;
    if (auth) {
      config.headers["Authorization"] = `Bearer ${auth.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      // useAuthStore.getState().clearToken();
    }
    return Promise.reject(error);
  }
);

export default apiClient;
